<template>
  <div class="dashboard-contenedor">
    <SlideBar @cambiar-estado="actualizarSidebar" />

    <div class="contenido" :class="{ 'contenido-expandido': sidebarCerrado }">

      <div class="page-header">
        <div>
          <p class="eyebrow">Administración</p>
          <h2 class="titulo">Doctores</h2>
        </div>
        <div class="header-acciones">
          <label class="toggle-eliminados">
            <input type="checkbox" v-model="mostrarEliminados">
            Mostrar eliminados
          </label>
          <button class="btn-agregar" @click="abrirModal">
            <span class="material-icons">person_add</span>
            Agregar doctor
          </button>
        </div>
      </div>

      <!-- Estado de carga -->
      <div v-if="cargando" class="estado-cargando">
        <div class="spinner"></div>
        <p>Cargando doctores...</p>
      </div>

      <!-- Estado vacío -->
      <div v-else-if="!doctoresVisibles.length" class="estado-vacio">
        <span class="material-icons estado-icon">people</span>
        <p>{{ mostrarEliminados ? 'No hay doctores eliminados.' : 'No hay doctores registrados.' }}</p>
      </div>

      <!-- Tabla de doctores -->
      <div v-else class="tabla-card">
        <div class="tabla-scroll">
          <table class="tabla">
            <thead>
              <tr>
                <th>Nombre completo</th>
                <th>Usuario</th>
                <th>Cédula</th>
                <th>Rango</th>
                <th>Teléfono</th>
                <th>Correo</th>
                <!-- Columnas para documentos -->
                <th class="th-centro">Cédula</th>
                <th class="th-centro">Firma</th>
                <th class="th-centro">Credenciales</th>
                <th class="th-centro">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="d in doctoresVisibles" :key="d.id" :class="{ 'fila-eliminada': !esActivo(d.activo) }">
                <td class="td-nombre">
                  {{ d.nombre }} {{ d.apellido_paterno }}
                  <span v-if="d.apellido_materno"> {{ d.apellido_materno }}</span>
                </td>
                <td class="td-mono">{{ d.usuario }}</td>
                <td>{{ d.cedula || '—' }}</td>
                <td>
                  <span class="rango-badge" :class="`rango-${d.rango}`">
                    {{ labelRango(d.rango) }}
                  </span>
                </td>
                <td>{{ d.telefono }}</td>
                <td class="td-correo">{{ d.correo }}</td>
                <!-- Indicadores de documentos + descarga y carga -->
                <td class="td-centro">
                  <div class="doc-cell">
                    <button v-if="d.cedula_archivo" class="btn-ojo icono-ok" title="Descargar cédula" @click="descargarArchivo(d.cedula_archivo, `cedula_${d.usuario}`)">
                      <span class="material-icons">download</span>
                    </button>
                    <span v-else class="icono-faltante" title="Sin cédula">
                      <span class="material-icons">cancel</span>
                    </span>
                    <button class="btn-subir-mini" :title="d.cedula_archivo ? 'Reemplazar cédula' : 'Subir cédula'" @click="abrirModalDocumentos(d)">
                      <span class="material-icons" style="font-size:16px;">upload_file</span>
                    </button>
                  </div>
                </td>
                <td class="td-centro">
                  <div class="doc-cell">
                    <button v-if="d.firma_archivo" class="btn-ojo icono-ok" title="Descargar firma" @click="descargarArchivo(d.firma_archivo, `firma_${d.usuario}`)">
                      <span class="material-icons">download</span>
                    </button>
                    <span v-else class="icono-faltante" title="Sin firma">
                      <span class="material-icons">cancel</span>
                    </span>
                    <button class="btn-subir-mini" :title="d.firma_archivo ? 'Reemplazar firma' : 'Subir firma'" @click="abrirModalDocumentos(d)">
                      <span class="material-icons" style="font-size:16px;">upload_file</span>
                    </button>
                  </div>
                </td>
                <td class="td-centro">
                  <button
                    v-if="d.rango !== 'administrador'"
                    class="btn-ojo"
                    title="Restablecer contraseña"
                    @click="regenerarPassword(d)"
                  >
                    <span class="material-icons">lock_reset</span>
                  </button>
                  <span v-else class="icono-lock" title="No disponible por seguridad">
                    <span class="material-icons">lock</span>
                  </span>
                </td>
                <td class="td-centro">
                  <div class="acciones-wrap">
                    <button v-if="esActivo(d.activo)" class="btn-ojo" title="Editar datos del doctor" @click="abrirModalEditar(d)">
                      <span class="material-icons">edit</span>
                    </button>
                    <button v-if="esActivo(d.activo)" class="btn-ojo btn-eliminar" title="Eliminar doctor" @click="eliminarDoctor(d)">
                      <span class="material-icons">delete</span>
                    </button>
                    <button v-else class="btn-ojo btn-restaurar" title="Restaurar doctor" @click="restaurarDoctor(d)">
                      <span class="material-icons">restore_from_trash</span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <!-- ══ MODAL REGISTRO ══════════════════════════════════════ -->
    <transition name="modal">
      <div v-if="mostrarModal" class="modal-overlay" @click.self="cerrarModal">
        <div class="modal-registro">

        <div class="modal-reg-header">
          <div>
            <h3>{{ modoEdicion ? 'Editar Doctor' : 'Agregar Doctor' }}</h3>
            <p>{{ modoEdicion ? 'Actualiza los datos del usuario médico' : 'Completa los datos del nuevo usuario médico' }}</p>
          </div>
          <button class="btn-close-modal" @click="cerrarModal">
            <span class="material-icons">close</span>
          </button>
        </div>

        <form @submit.prevent="guardarDoctor" class="modal-form">
          <div class="modal-body-scroll">
            <!-- Datos personales -->
            <div class="modal-seccion">
              <h4 class="modal-sec-titulo">
                <span class="material-icons">person</span>
                Datos personales
              </h4>
              <div class="campo-grid campo-cols-3">
                <div class="campo">
                  <label>Nombre <span class="req">*</span></label>
                  <input v-model.trim="form.nombre" type="text" maxlength="50" required>
                </div>
                <div class="campo">
                  <label>Apellido Paterno <span class="req">*</span></label>
                  <input v-model.trim="form.apellido_paterno" type="text" maxlength="50" required>
                </div>
                <div class="campo">
                  <label>Apellido Materno</label>
                  <input v-model.trim="form.apellido_materno" type="text" maxlength="50">
                </div>
              </div>
              <div class="campo-grid campo-cols-2">
                <div class="campo">
                  <label>Cédula Profesional</label>
                  <input v-model.trim="form.cedula" type="text" maxlength="20" placeholder="Ej. 1234567">
                </div>
                <div class="campo">
                  <label>Rango <span class="req">*</span></label>
                  <select v-model="form.rango" required>
                    <option value="" disabled>Seleccionar…</option>
                    <option value="doctor">Doctor</option>
                    <option value="nutriologo">Nutriólogo</option>
                    <option value="psicologo">Psicólogo</option>
                    <option value="jefe">Jefe médico</option>
                    <option value="administrador">Administrador</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Contacto -->
            <div class="modal-seccion">
              <h4 class="modal-sec-titulo">
                <span class="material-icons">contact_phone</span>
                Contacto
              </h4>
              <div class="campo-grid campo-cols-2">
                <div class="campo">
                  <label>Teléfono <span class="req">*</span></label>
                  <input v-model.trim="form.telefono" type="tel" maxlength="15"
                    placeholder="10 dígitos" required
                    @input="form.telefono = form.telefono.replace(/\D/g, '')">
                </div>
                <div class="campo">
                  <label>Correo electrónico <span class="req">*</span></label>
                  <input v-model.trim="form.correo" type="email" maxlength="100" required>
                </div>
              </div>
            </div>

            <!-- Credenciales -->
            <div class="modal-seccion modal-sec-credenciales">
              <h4 class="modal-sec-titulo">
                <span class="material-icons">key</span>
                Credenciales de acceso
              </h4>
              <p class="nota-credenciales">
                <span class="material-icons" style="font-size:14px;vertical-align:middle">info</span>
                Comparte estos datos con el doctor para que pueda iniciar sesión.
              </p>
              <div class="campo-grid campo-cols-2">
                <div class="campo">
                  <label>Usuario <span class="req" v-if="!modoEdicion">*</span></label>
                  <input v-model.trim="form.usuario" type="text" maxlength="30"
                    placeholder="Ej. drjuarez" autocomplete="off" :required="!modoEdicion" :disabled="modoEdicion">
                  <span class="hint-msg">{{ modoEdicion ? 'El usuario no se puede cambiar' : 'Solo letras y números, sin espacios' }}</span>
                </div>
                <div class="campo">
                  <label>Contraseña <span class="req" v-if="!modoEdicion">*</span></label>
                  <div class="input-pw-wrap">
                    <input
                      v-model.trim="form.contraseña"
                      :type="mostrarContrasena ? 'text' : 'password'"
                      maxlength="100"
                      :placeholder="modoEdicion ? 'Dejar en blanco para conservar actual' : 'Mínimo 6 caracteres'"
                      autocomplete="new-password"
                      :required="!modoEdicion"
                    >
                    <button type="button" class="btn-toggle-pw" @click="mostrarContrasena = !mostrarContrasena"
                      :title="mostrarContrasena ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                      <span class="material-icons">{{ mostrarContrasena ? 'visibility_off' : 'visibility' }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- ═══ NUEVA SECCIÓN: DOCUMENTOS ═══ -->
            <div class="modal-seccion">
              <h4 class="modal-sec-titulo">
                <span class="material-icons">description</span>
                Documentos (Cédula y Firma)
              </h4>
              <p class="nota-credenciales">
                <span class="material-icons" style="font-size:14px;vertical-align:middle">info</span>
                La cédula se almacena como PDF (o imagen) y la firma como imagen (PNG, JPG, etc.)
              </p>
              <div class="campo-grid campo-cols-2">
                <div class="campo">
                  <label>Cédula Profesional</label>
                  <input type="file" accept=".pdf,.jpg,.jpeg,.png" @change="onCedulaChange" />
                  <span v-if="form.cedula_archivo" class="file-ok">
                    <span class="material-icons" style="font-size:16px;vertical-align:middle;">check_circle</span>
                    Archivo cargado
                  </span>
                  <span v-else class="file-hint">PDF o imagen (máx. 5MB)</span>
                </div>
                <div class="campo">
                  <label>Firma Digitalizada</label>
                  <input type="file" accept="image/*" @change="onFirmaChange" />
                  <span v-if="form.firma_archivo" class="file-ok">
                    <span class="material-icons" style="font-size:16px;vertical-align:middle;">check_circle</span>
                    Archivo cargado
                  </span>
                  <span v-else class="file-hint">Imagen (PNG, JPG, etc.)</span>
                  <!-- Vista previa de la firma si es imagen -->
                  <div v-if="form.firma_preview" class="firma-preview">
                    <img :src="form.firma_preview" alt="Vista previa de firma" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn-cancelar" @click="cerrarModal" :disabled="guardando">Cancelar</button>
            <button type="submit" class="btn-registrar" :disabled="guardando">
              <span class="material-icons">{{ guardando ? 'hourglass_top' : 'save' }}</span>
              {{ guardando ? 'Guardando...' : (modoEdicion ? 'Guardar cambios' : 'Registrar doctor') }}
            </button>
          </div>
        </form>
      </div>
    </div>
    </transition>

    <!-- ══ MODAL SUBIR / ACTUALIZAR DOCUMENTOS DOCTOR ════════════ -->
    <transition name="modal">
      <div v-if="mostrarModalDocs" class="modal-overlay" @click.self="cerrarModalDocumentos">
        <div class="modal-registro modal-documentos">
          <div class="modal-reg-header">
            <div>
              <h3>Documentos de {{ doctorEditandoDocs ? `${doctorEditandoDocs.nombre} ${doctorEditandoDocs.apellido_paterno}` : '' }}</h3>
              <p>Cédula profesional y firma digitalizada</p>
            </div>
            <button type="button" class="btn-close-modal" @click="cerrarModalDocumentos">
              <span class="material-icons">close</span>
            </button>
          </div>

          <form @submit.prevent="guardarDocumentos" class="modal-form">
            <div class="modal-body-scroll">
              <div class="modal-seccion" style="margin-top:0;">
                <div class="campo-grid campo-cols-2">
                  <div class="campo">
                    <label>Cédula Profesional</label>
                    <input type="file" accept=".pdf,.jpg,.jpeg,.png" @change="onDocsCedulaChange" />
                    <span v-if="docsForm.cedula_archivo" class="file-ok">
                      <span class="material-icons" style="font-size:16px;vertical-align:middle;">check_circle</span>
                      Cédula disponible
                    </span>
                    <span v-else class="file-hint">PDF o imagen (máx. 10MB)</span>
                  </div>
                  <div class="campo">
                    <label>Firma Digitalizada</label>
                    <input type="file" accept="image/*" @change="onDocsFirmaChange" />
                    <span v-if="docsForm.firma_archivo" class="file-ok">
                      <span class="material-icons" style="font-size:16px;vertical-align:middle;">check_circle</span>
                      Firma disponible
                    </span>
                    <span v-else class="file-hint">Imagen (PNG, JPG, etc.)</span>
                    <div v-if="docsForm.firma_preview" class="firma-preview">
                      <img :src="docsForm.firma_preview" alt="Vista previa de firma" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn-cancelar" @click="cerrarModalDocumentos">Cancelar</button>
              <button type="submit" class="btn-registrar" :disabled="guardandoDocs">
                <span class="material-icons">{{ guardandoDocs ? 'hourglass_top' : 'save' }}</span>
                {{ guardandoDocs ? 'Guardando...' : 'Guardar documentos' }}
              </button>
            </div>
          </form>
      </div>
    </div>
    </transition>

  </div>
</template>

<script>
import SlideBar from '@/components/SlideBar.vue';
import Swal from 'sweetalert2';
import DOMPurify from 'dompurify';
import { getUsuarios, addUsuario, setUsuarioActivo, updateUsuario, verifyPassword, uploadDocumentosUsuario } from '@/utils/api';

const RANGOS = {
  administrador: 'Administrador',
  jefe: 'Jefe médico',
  doctor: 'Doctor',
  nutriologo: 'Nutriólogo',
  psicologo: 'Psicólogo',
};

function comprimirImagen(file, maxDimension = 600, calidad = 0.85) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = (e) => {
      const img = new Image();
      img.onerror = reject;
      img.onload = () => {
        let { width, height } = img;
        if (width > maxDimension || height > maxDimension) {
          if (width > height) {
            height = Math.round((height * maxDimension) / width);
            width = maxDimension;
          } else {
            width = Math.round((width * maxDimension) / height);
            height = maxDimension;
          }
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        const isPng = file.type === 'image/png';
        resolve(canvas.toDataURL(isPng ? 'image/png' : 'image/jpeg', calidad));
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
}

function formVacio() {
  return {
    nombre: '',
    apellido_paterno: '',
    apellido_materno: '',
    cedula: '',
    rango: '',
    telefono: '',
    correo: '',
    usuario: '',
    contraseña: '',
    // Nuevos campos para documentos
    cedula_archivo: null,    // base64 del PDF/imagen
    cedula_file: null,       // File nativo para FormData
    firma_archivo: null,     // base64 de la imagen de firma
    firma_file: null,        // File nativo para FormData
    firma_preview: null,     // URL para previsualización (solo para mostrar)
  };
}

export default {
  name: 'AdministracionDoctores',
  components: { SlideBar },
  data() {
    return {
      sidebarCerrado: false,
      cargando: true,
      doctores: [],
      mostrarModal: false,
      mostrarEliminados: false,
      mostrarContrasena: true,
      modoEdicion: false,
      doctorEditandoId: null,
      form: formVacio(),
      mostrarModalDocs: false,
      doctorEditandoDocs: null,
      docsForm: {
        cedula_archivo: null,
        cedula_file: null,
        firma_archivo: null,
        firma_file: null,
        firma_preview: null,
      },
      guardandoDocs: false,
      guardando: false,
    };
  },
  computed: {
    doctoresVisibles() {
      return this.doctores.filter(d => {
        const activo = this.esActivo(d.activo);
        return this.mostrarEliminados ? !activo : activo;
      });
    },
  },
  created() { this.cargarDoctores(); },
  methods: {
    actualizarSidebar(estado) { this.sidebarCerrado = estado; },
    labelRango(r) { return RANGOS[r] || r; },
    esActivo(val) {
      return val === true || val === 1 || val === '1';
    },

    async cargarDoctores() {
      this.cargando = true;
      try {
        this.doctores = await getUsuarios();
      } catch (err) {
        console.error('Error cargando doctores:', err);
      } finally {
        this.cargando = false;
      }
    },

    abrirModal() {
      this.modoEdicion = false;
      this.doctorEditandoId = null;
      this.form = formVacio();
      this.mostrarContrasena = true;
      this.mostrarModal = true;
    },

    abrirModalEditar(doctor) {
      this.modoEdicion = true;
      this.doctorEditandoId = doctor.id;
      this.form = {
        nombre: doctor.nombre || '',
        apellido_paterno: doctor.apellido_paterno || '',
        apellido_materno: doctor.apellido_materno || '',
        cedula: doctor.cedula || '',
        rango: doctor.rango || '',
        telefono: doctor.telefono || '',
        correo: doctor.correo || '',
        usuario: doctor.usuario || '',
        contraseña: '',
        cedula_archivo: doctor.cedula_archivo || null,
        cedula_file: null,
        firma_archivo: doctor.firma_archivo || null,
        firma_file: null,
        firma_preview: doctor.firma_archivo || null,
      };
      this.mostrarContrasena = false;
      this.mostrarModal = true;
    },

    cerrarModal() {
      this.mostrarModal = false;
      this.modoEdicion = false;
      this.doctorEditandoId = null;
      this.form = formVacio();
      this.mostrarContrasena = true;
    },

    // ── Manejo de archivos ──
    async onCedulaChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      if (file.size > 10 * 1024 * 1024) {
        Swal.fire('Archivo demasiado grande', 'La cédula no debe superar los 10MB.', 'warning');
        e.target.value = '';
        return;
      }
      this.form.cedula_file = file;
      if (file.type.startsWith('image/')) {
        try {
          this.form.cedula_archivo = await comprimirImagen(file, 1200, 0.85);
        } catch {
          const reader = new FileReader();
          reader.onload = (ev) => { this.form.cedula_archivo = ev.target.result; };
          reader.readAsDataURL(file);
        }
      } else {
        const reader = new FileReader();
        reader.onload = (ev) => { this.form.cedula_archivo = ev.target.result; };
        reader.readAsDataURL(file);
      }
    },

    async onFirmaChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      if (file.size > 5 * 1024 * 1024) {
        Swal.fire('Archivo demasiado grande', 'La firma no debe superar los 5MB.', 'warning');
        e.target.value = '';
        return;
      }
      this.form.firma_file = file;
      try {
        const base64 = await comprimirImagen(file, 600, 0.85);
        this.form.firma_archivo = base64;
        this.form.firma_preview = base64;
      } catch {
        const reader = new FileReader();
        reader.onload = (ev) => {
          this.form.firma_archivo = ev.target.result;
          this.form.firma_preview = ev.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    abrirModalDocumentos(doctor) {
      this.doctorEditandoDocs = doctor;
      this.docsForm = {
        cedula_archivo: doctor.cedula_archivo || null,
        cedula_file: null,
        firma_archivo: doctor.firma_archivo || null,
        firma_file: null,
        firma_preview: doctor.firma_archivo || null,
      };
      this.mostrarModalDocs = true;
    },

    cerrarModalDocumentos() {
      this.mostrarModalDocs = false;
      this.doctorEditandoDocs = null;
      this.docsForm = {
        cedula_archivo: null,
        cedula_file: null,
        firma_archivo: null,
        firma_file: null,
        firma_preview: null,
      };
      this.guardandoDocs = false;
    },

    async onDocsCedulaChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      if (file.size > 10 * 1024 * 1024) {
        Swal.fire('Archivo demasiado grande', 'La cédula no debe superar los 10MB.', 'warning');
        e.target.value = '';
        return;
      }
      this.docsForm.cedula_file = file;
      if (file.type.startsWith('image/')) {
        try {
          this.docsForm.cedula_archivo = await comprimirImagen(file, 1200, 0.85);
        } catch {
          const reader = new FileReader();
          reader.onload = (ev) => { this.docsForm.cedula_archivo = ev.target.result; };
          reader.readAsDataURL(file);
        }
      } else {
        const reader = new FileReader();
        reader.onload = (ev) => { this.docsForm.cedula_archivo = ev.target.result; };
        reader.readAsDataURL(file);
      }
    },

    async onDocsFirmaChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      if (file.size > 5 * 1024 * 1024) {
        Swal.fire('Archivo demasiado grande', 'La firma no debe superar los 5MB.', 'warning');
        e.target.value = '';
        return;
      }
      this.docsForm.firma_file = file;
      try {
        const base64 = await comprimirImagen(file, 600, 0.85);
        this.docsForm.firma_archivo = base64;
        this.docsForm.firma_preview = base64;
      } catch {
        const reader = new FileReader();
        reader.onload = (ev) => {
          this.docsForm.firma_archivo = ev.target.result;
          this.docsForm.firma_preview = ev.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    async guardarDocumentos() {
      if (!this.doctorEditandoDocs) return;
      const f = this.docsForm;
      if (!f.cedula_file && !f.cedula_archivo && !f.firma_file && !f.firma_archivo) {
        Swal.fire('Atención', 'Selecciona al menos un archivo para guardar.', 'info');
        return;
      }

      this.guardandoDocs = true;
      const formData = new FormData();
      if (f.cedula_file) {
        formData.append('cedula_archivo', f.cedula_file);
      } else if (f.cedula_archivo) {
        formData.append('cedula_archivo', f.cedula_archivo);
      }

      if (f.firma_file && !f.firma_archivo?.startsWith('data:image/')) {
        formData.append('firma_archivo', f.firma_file);
      } else if (f.firma_archivo) {
        formData.append('firma_archivo', f.firma_archivo);
      }

      try {
        await uploadDocumentosUsuario(this.doctorEditandoDocs.id, formData);
        await Swal.fire({ icon: 'success', title: 'Documentos actualizados', timer: 1500, showConfirmButton: false });
        this.cerrarModalDocumentos();
        this.cargarDoctores();
      } catch (error) {
        Swal.fire('Error', error.message || 'No se pudieron guardar los documentos', 'error');
      } finally {
        this.guardandoDocs = false;
      }
    },

    async regenerarPassword(doctor) {
      const { value: adminPass, isConfirmed } = await Swal.fire({
        title: 'Verificación requerida',
        text: 'Ingresa tu contraseña de administrador para cambiar la contraseña de este doctor',
        input: 'password',
        inputPlaceholder: 'Contraseña de administrador',
        showCancelButton: true,
        confirmButtonText: 'Verificar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#133E68',
        inputAttributes: { autocomplete: 'current-password' },
      });
      if (!isConfirmed || !adminPass) return;

      let valido;
      try {
        valido = await verifyPassword(adminPass);
      } catch {
        valido = false;
      }
      if (!valido) {
        Swal.fire({ icon: 'error', title: 'Contraseña incorrecta', confirmButtonColor: '#133E68' });
        return;
      }

      const nombre = `${doctor.nombre} ${doctor.apellido_paterno}`;
      const { value: nuevaContrasena, isConfirmed: confirmoNueva } = await Swal.fire({
        title: `Nueva contraseña — ${nombre}`,
        input: 'text',
        inputPlaceholder: 'Escribe la nueva contraseña',
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#133E68',
        inputValidator: (value) => (!value || value.length < 6) ? 'Mínimo 6 caracteres.' : undefined,
      });
      if (!confirmoNueva || !nuevaContrasena) return;

      try {
        await updateUsuario(doctor.id, { contraseña: nuevaContrasena, contrasena: nuevaContrasena });
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'No se pudo actualizar', text: error.message, confirmButtonColor: '#d33' });
        return;
      }

      Swal.fire({ icon: 'success', title: 'Contraseña actualizada', confirmButtonColor: '#133E68' });
    },

    async guardarDoctor() {
      const f = this.form;
      const limpiar = (v, max = 100) => DOMPurify.sanitize(String(v || '')).substring(0, max).trim();

      if (f.telefono && !/^\d{7,15}$/.test(f.telefono)) {
        Swal.fire('Teléfono inválido', 'Ingresa entre 7 y 15 dígitos.', 'warning');
        return;
      }

      if (!this.modoEdicion) {
        if (!f.contraseña || f.contraseña.length < 6) {
          Swal.fire('Contraseña muy corta', 'Mínimo 6 caracteres.', 'warning');
          return;
        }
        if (!f.usuario || /\s/.test(f.usuario)) {
          Swal.fire('Usuario inválido', 'El usuario es obligatorio y no puede contener espacios.', 'warning');
          return;
        }
      } else {
        if (f.contraseña && f.contraseña.length < 6) {
          Swal.fire('Contraseña muy corta', 'Mínimo 6 caracteres si deseas actualizarla.', 'warning');
          return;
        }
      }

      this.guardando = true;

      try {
        if (this.modoEdicion) {
          if (f.cedula_file || f.firma_file) {
            const formData = new FormData();
            formData.append('nombre', limpiar(f.nombre, 50));
            formData.append('apellido_paterno', limpiar(f.apellido_paterno, 50));
            formData.append('apellido_materno', limpiar(f.apellido_materno, 50));
            formData.append('cedula', limpiar(f.cedula, 20));
            formData.append('telefono', limpiar(f.telefono, 15));
            formData.append('correo', limpiar(f.correo, 100));
            formData.append('rango', limpiar(f.rango, 15));

            if (f.contraseña) {
              formData.append('contraseña', limpiar(f.contraseña, 100));
              formData.append('contrasena', limpiar(f.contraseña, 100));
            }

            if (f.cedula_file) {
              formData.append('cedula_archivo', f.cedula_file);
            }
            if (f.firma_file) {
              formData.append('firma_archivo', f.firma_file);
            }

            await updateUsuario(this.doctorEditandoId, formData);
          } else {
            const payload = {
              nombre: limpiar(f.nombre, 50),
              apellido_paterno: limpiar(f.apellido_paterno, 50),
              apellido_materno: limpiar(f.apellido_materno, 50),
              cedula: limpiar(f.cedula, 20),
              telefono: limpiar(f.telefono, 15),
              correo: limpiar(f.correo, 100),
              rango: limpiar(f.rango, 15),
            };
            if (f.contraseña) {
              payload.contraseña = limpiar(f.contraseña, 100);
              payload.contrasena = limpiar(f.contraseña, 100);
            }
            await updateUsuario(this.doctorEditandoId, payload);
          }

          this.cerrarModal();
          this.cargarDoctores();
          Swal.fire({
            icon: 'success',
            title: 'Doctor actualizado',
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          const formData = new FormData();
          formData.append('nombre', limpiar(f.nombre, 50));
          formData.append('apellido_paterno', limpiar(f.apellido_paterno, 50));
          formData.append('apellido_materno', limpiar(f.apellido_materno, 50));
          formData.append('cedula', limpiar(f.cedula, 20));
          formData.append('telefono', limpiar(f.telefono, 15));
          formData.append('correo', limpiar(f.correo, 100));
          formData.append('rango', limpiar(f.rango, 15));
          formData.append('usuario', limpiar(f.usuario, 30));
          formData.append('contraseña', limpiar(f.contraseña, 100));
          formData.append('contrasena', limpiar(f.contraseña, 100));

          if (f.cedula_file) {
            formData.append('cedula_archivo', f.cedula_file);
          } else if (f.cedula_archivo && !f.cedula_archivo.startsWith('http')) {
            formData.append('cedula_archivo', f.cedula_archivo);
          }

          if (f.firma_file) {
            formData.append('firma_archivo', f.firma_file);
          } else if (f.firma_archivo && !f.firma_archivo.startsWith('http')) {
            formData.append('firma_archivo', f.firma_archivo);
          }

          const resp = await addUsuario(formData);
          const user = resp?.usuario || f.usuario;
          this.cerrarModal();
          this.cargarDoctores();
          Swal.fire({
            icon: 'success',
            title: 'Doctor registrado',
            text: `Usuario: ${user}`,
            confirmButtonColor: '#133E68',
          });
        }
      } catch (error) {
        Swal.fire('Error', error.message || 'No se pudo procesar la solicitud', 'error');
      } finally {
        this.guardando = false;
      }
    },

    descargarArchivo(base64, nombreBase) {
      if (!base64) return;
      const extension = base64.substring(base64.indexOf('/') + 1, base64.indexOf(';'));
      const link = document.createElement('a');
      link.href = base64;
      link.download = `${nombreBase}.${extension || 'bin'}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    async eliminarDoctor(doctor) {
      const { isConfirmed } = await Swal.fire({
        icon: 'warning',
        title: '¿Eliminar doctor?',
        text: `"${doctor.nombre} ${doctor.apellido_paterno}" dejará de poder iniciar sesión, pero su historial de consultas se conserva. Puedes restaurarlo cuando quieras.`,
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
      });
      if (!isConfirmed) return;
      await setUsuarioActivo(doctor.id, false);
      this.cargarDoctores();
      Swal.fire({ icon: 'success', title: 'Doctor eliminado', confirmButtonColor: '#133E68' });
    },

    async restaurarDoctor(doctor) {
      await setUsuarioActivo(doctor.id, true);
      this.cargarDoctores();
      Swal.fire({ icon: 'success', title: 'Doctor restaurado', confirmButtonColor: '#133E68' });
    },
  },
};
</script>

<style scoped>
/* ---------- LAYOUT ---------- */
.dashboard-contenedor {
  display: flex;
  min-height: 100vh;
  background: var(--brand-beige, #f8f5f1);
}

.contenido {
  flex-grow: 1;
  padding: 28px 32px;
  margin-left: 250px;
  transition: margin-left 0.3s ease;
}

.contenido-expandido {
  margin-left: 80px;
}

/* ---------- HEADER ---------- */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 28px;
  flex-wrap: wrap;
}

.eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--brand-accent-sage, #607f70);
  margin: 0 0 4px;
}

.titulo {
  font-size: 28px;
  font-weight: 700;
  color: var(--brand-primary, #133e68);
  margin: 0;
}

.btn-agregar {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: var(--brand-primary, #133e68);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s;
}

.btn-agregar:hover {
  background: var(--brand-accent-navy, #0d2a47);
  transform: translateY(-1px);
}

.header-acciones {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.toggle-eliminados {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--brand-secondary, #333);
  cursor: pointer;
  white-space: nowrap;
}

.fila-eliminada { opacity: 0.55; }

.btn-eliminar:hover { color: #d33; background: rgba(211, 51, 51, 0.08); }
.btn-restaurar:hover { color: var(--brand-accent-sage, #607f70); background: rgba(96, 127, 112, 0.12); }

/* ---------- ESTADO DE CARGA ---------- */
.estado-cargando {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 80px 24px;
  color: var(--brand-primary, #133e68);
  font-weight: 600;
}

.spinner {
  width: 44px;
  height: 44px;
  border: 4px solid rgba(19, 62, 104, 0.12);
  border-top-color: var(--brand-accent-sage, #607f70);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ---------- ESTADO VACÍO ---------- */
.estado-vacio {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 80px 24px;
  color: var(--brand-secondary-light, #999);
}

.estado-icon {
  font-size: 64px;
  opacity: 0.3;
}

.estado-vacio p {
  font-size: 15px;
  font-weight: 500;
  margin: 0;
}

.acciones-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

/* ---------- TABLA ---------- */
.tabla-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 16px rgba(19, 62, 104, 0.08);
  overflow: hidden;
}

.tabla-scroll {
  overflow-x: auto;
}

.tabla {
  width: 100%;
  min-width: 820px;
  border-collapse: collapse;
}

.tabla thead {
  background: var(--brand-primary, #133e68);
  color: #fff;
}

.tabla th {
  padding: 14px 16px;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  white-space: nowrap;
}

.th-centro {
  text-align: center;
}

.tabla tbody tr {
  border-bottom: 1px solid rgba(19, 62, 104, 0.07);
  transition: background 0.15s;
}

.tabla tbody tr:last-child {
  border-bottom: none;
}

.tabla tbody tr:hover {
  background: rgba(96, 127, 112, 0.06);
}

.tabla td {
  padding: 14px 16px;
  font-size: 13px;
  color: var(--brand-secondary, #333);
  vertical-align: middle;
}

.td-nombre {
  font-weight: 600;
  color: var(--brand-primary, #133e68);
}

.td-mono {
  font-family: 'Courier New', monospace;
  font-size: 13px;
}

.td-correo {
  font-size: 12px;
}

.td-centro {
  text-align: center;
}

/* ---------- RANGO BADGE ---------- */
.rango-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.rango-administrador {
  background: rgba(19, 62, 104, 0.12);
  color: #133e68;
}

.rango-jefe {
  background: rgba(96, 127, 112, 0.15);
  color: #4a6255;
}

.rango-doctor {
  background: rgba(48, 80, 101, 0.12);
  color: #305065;
}

.rango-nutriologo {
  background: rgba(96, 127, 112, 0.15);
  color: #607f70;
}

.rango-psicologo {
  background: rgba(157, 108, 176, 0.15);
  color: #7a4d8c;
}

/* ---------- INDICADORES DOCUMENTOS ---------- */
.icono-ok .material-icons,
.icono-faltante .material-icons {
  font-size: 20px;
}

.icono-ok .material-icons {
  color: #4a7c59;
}

.icono-faltante .material-icons {
  color: #bbb;
}

/* ---------- OJO / LOCK ---------- */
.btn-ojo {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--brand-accent-sage, #607f70);
  padding: 4px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  transition: color 0.2s, background 0.2s;
}

.btn-ojo:hover {
  color: var(--brand-primary, #133e68);
  background: rgba(19, 62, 104, 0.08);
}

.btn-ojo .material-icons {
  font-size: 20px;
}

.icono-lock {
  color: var(--brand-secondary-light, #999);
  display: inline-flex;
  align-items: center;
  opacity: 0.5;
}

.icono-lock .material-icons {
  font-size: 20px;
}

/* ══════════════════════════════════════════
   MODAL REGISTRO — REDISEÑADO AMPLIO
══════════════════════════════════════════ */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1400;
  padding: 20px;
  backdrop-filter: blur(2px);
}

.modal-registro {
  width: min(920px, 95vw);
  max-height: 86vh;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.28);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-reg-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 26px;
  background: var(--brand-primary, #133e68);
  border-radius: 18px 18px 0 0;
}

.modal-reg-header h3 {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.modal-reg-header p {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75);
}

.btn-close-modal {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  transition: color 0.2s;
}

.btn-close-modal:hover {
  color: #fff;
}

.btn-close-modal .material-icons {
  font-size: 24px;
}

/* ---------- FORMULARIO ---------- */
.modal-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  gap: 0;
}

.modal-body-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 20px 26px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overscroll-behavior: contain;
}

.modal-seccion {
  display: flex;
  flex-direction: column;
  gap: 14px;
  background: #fafaf9;
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.modal-sec-titulo {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: var(--brand-accent-sage, #607f70);
  text-transform: uppercase;
  letter-spacing: 0.8px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(96, 127, 112, 0.15);
}

.modal-sec-titulo .material-icons {
  font-size: 18px;
}

.modal-sec-credenciales {
  background: rgba(248, 245, 241, 0.8);
  border-left: 4px solid var(--brand-accent-sage, #607f70);
}

.nota-credenciales {
  font-size: 13px;
  color: var(--brand-secondary-light, #777);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* ---------- CAMPOS ---------- */
.campo-grid {
  display: grid;
  gap: 18px 24px;
}

.campo-grid.campo-cols-3 {
  grid-template-columns: repeat(3, minmax(160px, 1fr));
}

.campo-grid.campo-cols-2 {
  grid-template-columns: repeat(2, minmax(200px, 1fr));
}

.campo {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

label {
  font-size: 14px;
  font-weight: 600;
  color: var(--brand-secondary, #333);
  letter-spacing: 0.3px;
}

.req {
  color: #d0314e;
  margin-left: 2px;
}

input,
select {
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid #dcdcdc;
  border-radius: 8px;
  font-size: 14px;
  color: var(--brand-secondary, #333);
  background: #fff;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
  height: 44px;
}

input:focus,
select:focus {
  outline: none;
  border-color: var(--brand-accent-sage, #607f70);
  box-shadow: 0 0 0 4px rgba(96, 127, 112, 0.12);
}

select {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='8' viewBox='0 0 14 8'%3E%3Cpath d='M1 1l6 6 6-6' stroke='%23999' stroke-width='2' fill='none' stroke-linecap='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 40px;
  cursor: pointer;
}

.hint-msg {
  font-size: 12px;
  color: var(--brand-secondary-light, #888);
  margin-top: 2px;
}

/* ---------- PASSWORD INPUT ---------- */
.input-pw-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.input-pw-wrap input {
  padding-right: 48px;
}

.btn-toggle-pw {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--brand-secondary-light, #888);
  padding: 0;
  display: flex;
  align-items: center;
  transition: color 0.2s;
}

.btn-toggle-pw:hover {
  color: var(--brand-primary, #133e68);
}

.btn-toggle-pw .material-icons {
  font-size: 22px;
}

/* ---------- ARCHIVOS ---------- */
.campo input[type="file"] {
  padding: 10px 12px;
  height: auto;
  border: 2px dashed #d0d0d0;
  background: #f9f9f8;
  cursor: pointer;
  border-radius: 10px;
  font-size: 13px;
  color: var(--brand-secondary-light, #666);
}

.campo input[type="file"]:hover {
  border-color: var(--brand-accent-sage, #607f70);
}

.file-ok {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
  color: #4a7c59;
  font-size: 13px;
  font-weight: 500;
}

.file-ok .material-icons {
  font-size: 18px;
}

.file-hint {
  display: block;
  color: #999;
  font-size: 12px;
  margin-top: 2px;
}

.firma-preview {
  margin-top: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 6px;
  max-width: 160px;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.firma-preview img {
  max-width: 100%;
  max-height: 70px;
  display: block;
}

/* ---------- FOOTER DEL MODAL ---------- */
.modal-footer {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 14px 26px;
  background: #ffffff;
  border-top: 1px solid #e8edf2;
  box-shadow: 0 -4px 14px rgba(0, 0, 0, 0.04);
  margin-top: 0;
}

.btn-cancelar {
  padding: 10px 24px;
  border: 1.5px solid #dcdcdc;
  border-radius: 8px;
  background: transparent;
  color: var(--brand-secondary, #333);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s, background 0.2s;
}

.btn-cancelar:hover {
  border-color: var(--brand-primary, #133e68);
  color: var(--brand-primary, #133e68);
  background: rgba(19, 62, 104, 0.04);
}

.btn-registrar {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 26px;
  background: var(--brand-accent-sage, #607f70);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s;
}

.btn-registrar:hover {
  background: var(--brand-accent-navy, #0d2a47);
  transform: translateY(-2px);
}

.btn-registrar .material-icons {
  font-size: 18px;
}

.btn-registrar:disabled,
.btn-cancelar:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

/* ---------- RESPONSIVE ---------- */
@media (max-width: 820px) {
  .campo-grid.campo-cols-3 {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 640px) {
  .campo-grid.campo-cols-3,
  .campo-grid.campo-cols-2 {
    grid-template-columns: 1fr;
  }

  .modal-registro {
    width: 96vw;
    max-height: 94vh;
  }

  .modal-body-scroll {
    padding: 16px 14px;
    gap: 14px;
  }

  .modal-seccion {
    padding: 14px 14px;
  }

  input,
  select {
    height: 42px;
    padding: 8px 12px;
    font-size: 13px;
  }

  .btn-registrar,
  .btn-cancelar {
    padding: 10px 18px;
    font-size: 13px;
    width: 100%;
    justify-content: center;
  }

  .modal-footer {
    flex-direction: column-reverse;
    padding: 12px 16px;
  }
}

/* ---------- SCROLLBAR DEL MODAL BODY ---------- */
.modal-body-scroll::-webkit-scrollbar {
  width: 7px;
}

.modal-body-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.modal-body-scroll::-webkit-scrollbar-thumb {
  background: #9ab4a7;
  border-radius: 4px;
}

.modal-body-scroll::-webkit-scrollbar-thumb:hover {
  background: var(--brand-primary, #133e68);
}

/* Documentos en tabla y modal */
.doc-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.btn-subir-mini {
  background: #f0f4f8;
  border: 1px solid #c9d8e5;
  border-radius: 6px;
  cursor: pointer;
  padding: 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--brand-primary, #133e68);
  transition: all 0.2s;
}

.btn-subir-mini:hover {
  border-color: var(--brand-primary, #133e68);
  background: #e1ebf4;
  transform: scale(1.05);
}

.modal-documentos {
  max-width: 600px;
}

@media (max-width: 1024px) {
  .contenido {
    margin-left: 80px;
  }
}
@media (max-width: 768px) {
  .contenido {
    margin-left: 0 !important;
    padding: 12px;
    padding-top: 70px;
  }
}
</style>
